import React from 'react';
import type { ReactChildren } from 'types/utility';

interface Props extends React.HTMLProps<HTMLInputElement> {
  lines: number;
  children: ReactChildren;
}

export default function Truncate(props: Props) {
  const { children, lines, style, ...rest } = props;
  // Forcibly apply styling as `style` instead of css selector, as certain properties got removed during build-time.
  // See https://css-tricks.com/almanac/properties/l/line-clamp/ for more details
  const containerStyle: React.CSSProperties = {
    overflow: 'hidden',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    display: '-webkit-box',
    lineClamp: lines,
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    // This adds just enough space for letter descenders so they don't get cut off
    paddingBottom: '0.1em',
    ...style,
  };
  return (
    <div {...rest} style={containerStyle}>
      {children}
    </div>
  );
}

Truncate.defaultProps = {
  lines: 1,
};
